"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customBooleanValidator = void 0;
const zod_1 = require("zod");
const utils_1 = require("../../utils");
exports.customBooleanValidator = zod_1.z
    .string()
    .refine(value => utils_1.customBoolDict[value.toLowerCase()] != undefined)
    .transform(value => (0, utils_1.stringAsBool)(value.toLowerCase(), true, true, utils_1.customBoolDict));
